@use '../colors.scss' as colors;

.loading-spinner {
  transform-origin: center;

  -webkit-animation-duration: 0.75s;
  -webkit-animation-name: spinner_75;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-duration: 0.75s;
  -moz-animation-name: spinner_75;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;
  animation-duration: 0.75s;
  animation-name: spinner_75;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes spinner_75 {
  100% {
    transform: rotate(360deg);
  }
}
